// Shared handler for all 4 CRM intake forms (snippets/ppp-crm-form.liquid).
// Contract: ../pioneer-ops/docs/CRM_INTAKE_API.md
(function () {
  var TURNSTILE_SRC = 'https://challenges.cloudflare.com/turnstile/v0/api.js';
  var MAX_FILES = 10;
  var MAX_FILE_SIZE_BYTES = 25 * 1024 * 1024;
  var ALLOWED_EXTENSIONS = [
    'pdf', 'doc', 'docx', 'xls', 'xlsx', 'csv', 'txt', 'rtf',
    'jpg', 'jpeg', 'png', 'gif', 'webp', 'heic', 'tif', 'tiff',
    'ai', 'eps', 'psd', 'svg', 'dxf', 'dwg'
  ];

  var TURNSTILE_WAIT_MS = 4000;
  var TURNSTILE_POLL_MS = 150;

  var turnstileLoadPromise = null;
  var turnstileWidgetIds = new WeakMap();
  var turnstileTokens = new WeakMap();

  function loadTurnstile() {
    if (turnstileLoadPromise) return turnstileLoadPromise;
    turnstileLoadPromise = new Promise(function (resolve) {
      if (window.turnstile) return resolve();
      var script = document.createElement('script');
      script.src = TURNSTILE_SRC;
      script.async = true;
      script.defer = true;
      script.onload = function () { resolve(); };
      document.head.appendChild(script);
    });
    return turnstileLoadPromise;
  }

  function renderTurnstile(form) {
    if (turnstileWidgetIds.has(form)) return;
    var container = form.querySelector('[data-crm-turnstile]');
    if (!container) return;
    loadTurnstile().then(function () {
      if (turnstileWidgetIds.has(form)) return;
      var widgetId = window.turnstile.render(container, {
        sitekey: (window.PPP_CRM_CONFIG && window.PPP_CRM_CONFIG.turnstileSiteKey) || container.getAttribute('data-sitekey'),
        // Invisible mode runs the check in the background with no visible
        // widget -- capture the token as soon as it's ready instead of only
        // checking getResponse() synchronously at submit time, which races
        // the background check on a fast click.
        callback: function (token) { turnstileTokens.set(form, token); },
        'error-callback': function () { turnstileTokens.delete(form); },
        'expired-callback': function () { turnstileTokens.delete(form); }
      });
      turnstileWidgetIds.set(form, widgetId);
    });
  }

  function getTurnstileToken(form) {
    var captured = turnstileTokens.get(form);
    if (captured) return captured;
    var widgetId = turnstileWidgetIds.get(form);
    if (widgetId === undefined || !window.turnstile) return '';
    return window.turnstile.getResponse(widgetId) || '';
  }

  // Invisible Turnstile resolves asynchronously (usually under a second, but
  // not instantly) -- a visitor who hits Submit right away would otherwise
  // get a confusing "please complete the verification challenge" error with
  // no challenge to complete. Poll briefly for the token before giving up.
  function waitForTurnstileToken(form) {
    var existing = getTurnstileToken(form);
    if (existing) return Promise.resolve(existing);
    return new Promise(function (resolve) {
      var waited = 0;
      var interval = setInterval(function () {
        var token = getTurnstileToken(form);
        waited += TURNSTILE_POLL_MS;
        if (token || waited >= TURNSTILE_WAIT_MS) {
          clearInterval(interval);
          resolve(token);
        }
      }, TURNSTILE_POLL_MS);
    });
  }

  function resetTurnstile(form) {
    turnstileTokens.delete(form);
    var widgetId = turnstileWidgetIds.get(form);
    if (widgetId !== undefined && window.turnstile) window.turnstile.reset(widgetId);
  }

  // Renders Turnstile for any .ppp-crm-form inside `root` that isn't rendered
  // yet. Exposed globally so modal open/close code (p-lk-generic-product.liquid)
  // can call it right when a modal becomes visible -- Turnstile can't size
  // itself correctly if rendered while its container is display:none.
  window.pppCrmForm = {
    renderVisible: function (root) {
      (root || document).querySelectorAll('.ppp-crm-form').forEach(renderTurnstile);
    }
  };

  function setDeep(target, path, value) {
    var parts = path.split('.');
    var cursor = target;
    for (var i = 0; i < parts.length - 1; i++) {
      var key = parts[i];
      var nextIsIndex = /^\d+$/.test(parts[i + 1]);
      if (cursor[key] === undefined) cursor[key] = nextIsIndex ? [] : {};
      cursor = cursor[key];
    }
    cursor[parts[parts.length - 1]] = value;
  }

  function collectFields(form) {
    var payload = {};
    form.querySelectorAll('[data-field]').forEach(function (el) {
      var path = el.getAttribute('data-field');
      var type = el.getAttribute('data-field-type');
      var value = el.value;
      if (type === 'number') {
        value = value === '' ? null : Number(value);
      } else if (type === 'boolean') {
        value = value === 'true' || value === true;
      }
      setDeep(payload, path, value);
    });
    return payload;
  }

  function validateFiles(fileList) {
    if (fileList.length > MAX_FILES) {
      return 'You can attach up to ' + MAX_FILES + ' files.';
    }
    for (var i = 0; i < fileList.length; i++) {
      var file = fileList[i];
      var ext = (file.name.split('.').pop() || '').toLowerCase();
      if (ALLOWED_EXTENSIONS.indexOf(ext) === -1) {
        return '"' + file.name + '" isn’t an allowed file type.';
      }
      if (file.size > MAX_FILE_SIZE_BYTES) {
        return '"' + file.name + '" is larger than 25 MB.';
      }
    }
    return null;
  }

  // Error/working status only -- success replaces the whole form body with
  // showSuccess() below instead, since a small status line was easy to miss
  // once the user had already scrolled down to the submit button.
  function setStatus(form, message, kind) {
    var statusEl = form.querySelector('[data-crm-status]');
    if (!statusEl) return;
    if (!message) {
      statusEl.hidden = true;
      statusEl.textContent = '';
      statusEl.className = 'ppp-crm-form__status';
      return;
    }
    statusEl.hidden = false;
    statusEl.textContent = message;
    statusEl.className = 'ppp-crm-form__status ppp-crm-form__status--' + kind;
    statusEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function showSuccess(form) {
    var body = form.querySelector('[data-crm-body]');
    var success = form.querySelector('[data-crm-success]');
    if (body) body.hidden = true;
    if (success) {
      success.hidden = false;
      success.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  function hideSuccess(form) {
    var body = form.querySelector('[data-crm-body]');
    var success = form.querySelector('[data-crm-success]');
    if (body) body.hidden = false;
    if (success) success.hidden = true;
  }

  function setSubmitting(form, isSubmitting) {
    var button = form.querySelector('[data-crm-submit]');
    if (button) button.disabled = isSubmitting;
  }

  function formatApiError(body, status) {
    if (status === 400 && body) {
      // Real API shape: {"error": "Invalid submission", "details": ["contact.email or ...", ...]}
      if (Array.isArray(body.details) && body.details.length) {
        return 'Please check: ' + body.details.join('; ');
      }
      if (body.error) return body.error;
    }
    if (status === 403) return 'Verification failed -- please try again.';
    if (status === 413) return 'Too many files, or a file is too large.';
    if (status === 415) return 'One of your files isn’t an allowed type.';
    if (status === 429) return 'Too many requests -- please try again in a moment.';
    return 'Something went wrong. Please try again, or contact us directly.';
  }

  function uploadFiles(files, uploads) {
    var uploadByName = {};
    (uploads || []).forEach(function (upload) { uploadByName[upload.name] = upload; });
    return Promise.all(files.map(function (file) {
      var upload = uploadByName[file.name];
      if (!upload) return Promise.resolve();
      return fetch(upload.url, {
        method: upload.method || 'PUT',
        headers: upload.headers || {},
        body: file
      }).then(function (res) {
        if (!res.ok) throw new Error('Upload of "' + file.name + '" failed. Please try again.');
      });
    }));
  }

  function handleSubmit(form, event) {
    event.preventDefault();
    setStatus(form, '', '');

    var honeypot = form.querySelector('[data-crm-honeypot]');
    if (honeypot && honeypot.value) {
      // Bot filled the hidden field -- pretend success, send nothing.
      form.reset();
      showSuccess(form);
      resetTurnstile(form);
      return;
    }

    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }

    var fileInput = form.querySelector('[data-crm-files]');
    var files = fileInput && fileInput.files ? Array.prototype.slice.call(fileInput.files) : [];
    var fileError = validateFiles(files);
    if (fileError) {
      setStatus(form, fileError, 'error');
      return;
    }

    // Invisible Turnstile resolves in the background (usually under a
    // second, but not instantly) -- disable the button and wait for it
    // rather than failing immediately with "please complete the
    // verification challenge," which makes no sense when there's no visible
    // challenge to complete.
    setSubmitting(form, true);

    waitForTurnstileToken(form).then(function (turnstileToken) {
      if (!turnstileToken) {
        setSubmitting(form, false);
        setStatus(form, 'Verification check failed -- please refresh the page and try again.', 'error');
        resetTurnstile(form);
        return;
      }

      var payload = collectFields(form);
      payload.form_name = form.getAttribute('data-form-name');
      payload.turnstile_token = turnstileToken;
      payload.tracking = window.pppTracking
        ? window.pppTracking.getPayload({ productHandle: form.getAttribute('data-product-handle') || '' })
        : {};
      payload.files = files.map(function (file) {
        return { name: file.name, content_type: file.type || 'application/octet-stream', size_bytes: file.size };
      });

      var endpoint = window.PPP_CRM_CONFIG && window.PPP_CRM_CONFIG.endpoint;
      fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (res) {
          return res.json().catch(function () { return {}; }).then(function (body) {
            return { ok: res.ok, status: res.status, body: body };
          });
        })
        .then(function (result) {
          if (!result.ok) throw { message: formatApiError(result.body, result.status) };
          return uploadFiles(files, result.body.uploads).then(function () { return result.body; });
        })
        .then(function (body) {
          form.reset();
          showSuccess(form);
          if (window.pppTracking) {
            window.pppTracking.fireGenerateLead(payload.form_name, body.inquiry_ref, payload.tracking.product_handle);
          }
        })
        .catch(function (err) {
          setStatus(form, (err && err.message) || 'Something went wrong. Please try again.', 'error');
        })
        .finally(function () {
          setSubmitting(form, false);
          resetTurnstile(form);
        });
    });
  }

  function renderFileList(form) {
    var fileInput = form.querySelector('[data-crm-files]');
    var listEl = form.querySelector('[data-crm-file-list]');
    var textEl = form.querySelector('[data-crm-dropzone-text]');
    if (!fileInput || !listEl) return;
    var files = Array.prototype.slice.call(fileInput.files || []);

    listEl.innerHTML = '';
    listEl.hidden = files.length === 0;
    files.forEach(function (file, index) {
      var item = document.createElement('li');
      var name = document.createElement('span');
      name.textContent = file.name;
      var remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'ppp-crm-form__file-remove';
      remove.setAttribute('aria-label', 'Remove ' + file.name);
      remove.textContent = '×';
      remove.addEventListener('click', function () {
        var remaining = files.filter(function (_, i) { return i !== index; });
        var transfer = new DataTransfer();
        remaining.forEach(function (f) { transfer.items.add(f); });
        fileInput.files = transfer.files;
        renderFileList(form);
      });
      item.appendChild(name);
      item.appendChild(remove);
      listEl.appendChild(item);
    });

    if (textEl) {
      textEl.textContent = files.length === 0
        ? 'Choose file or drag here'
        : files.length + ' file' + (files.length === 1 ? '' : 's') + ' selected';
    }
  }

  function initDropzone(form) {
    var dropzone = form.querySelector('[data-crm-dropzone]');
    var browseBtn = form.querySelector('[data-crm-browse]');
    var fileInput = form.querySelector('[data-crm-files]');
    if (!dropzone || !fileInput) return;

    if (browseBtn) {
      browseBtn.addEventListener('click', function () { fileInput.click(); });
    }
    dropzone.addEventListener('click', function (event) {
      if (event.target === browseBtn) return;
      fileInput.click();
    });
    fileInput.addEventListener('change', function () { renderFileList(form); });

    ['dragover', 'dragenter'].forEach(function (eventName) {
      dropzone.addEventListener(eventName, function (event) {
        event.preventDefault();
        dropzone.classList.add('is-dragover');
      });
    });
    ['dragleave', 'dragend'].forEach(function (eventName) {
      dropzone.addEventListener(eventName, function () { dropzone.classList.remove('is-dragover'); });
    });
    dropzone.addEventListener('drop', function (event) {
      event.preventDefault();
      dropzone.classList.remove('is-dragover');
      var dropped = event.dataTransfer && event.dataTransfer.files;
      if (!dropped || !dropped.length) return;
      var existing = Array.prototype.slice.call(fileInput.files || []);
      var transfer = new DataTransfer();
      existing.concat(Array.prototype.slice.call(dropped)).forEach(function (f) { transfer.items.add(f); });
      fileInput.files = transfer.files;
      renderFileList(form);
    });
  }

  function init() {
    document.querySelectorAll('.ppp-crm-form').forEach(function (form) {
      form.addEventListener('submit', function (event) { handleSubmit(form, event); });
      // Native form.reset() clears the real file input but not our custom
      // file-list UI -- the 'reset' event fires for any reset() call,
      // including the one in p-lk-generic-product.liquid's openFreshModal.
      form.addEventListener('reset', function () {
        window.setTimeout(function () { renderFileList(form); }, 0);
        hideSuccess(form);
      });
      initDropzone(form);
      // Forms on plain pages (Contact / Request a Quote) are visible immediately;
      // forms inside product-page modals render lazily via pppCrmForm.renderVisible
      // when their modal is actually opened.
      if (!form.closest('.p-modal')) renderTurnstile(form);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
